import React, { useState, useEffect } from "react";
import "./SendEmailModal.scss";
import newRequest from "../../context/newRequest";
import Swal from "sweetalert2";

const SendEmailModal = ({ isOpen, onClose, ticketSolved, dateInfo, closeData }) => {
  const [toEmail1, setToEmail1] = useState("");
  const [toEmail2, setToEmail2] = useState("");
  const [ccEmail1, setCcEmail1] = useState("noc@greenet.id");
  const [ccEmail2, setCcEmail2] = useState("");
  const [subject, setSubject] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);

  // 3 Pertanyaan Validasi
  const [valRootCause, setValRootCause] = useState(false);
  const [valAction, setValAction] = useState(false);
  const [valAging, setValAging] = useState(false);

  const isClosed = ticketSolved?.status_id?.toUpperCase() === "CLOSED";
  const ticketNumber = ticketSolved?.number_ticket && ticketSolved.number_ticket !== "null"
    ? ticketSolved.number_ticket
    : (ticketSolved?.ticket_id || "-");

  useEffect(() => {
    if (!isOpen || !ticketSolved?.ticket_id) return;

    setSubject(`[RFO] Laporan Penanganan Gangguan Layanan - Tiket ${ticketNumber}`);
    setNote(ticketSolved.note || "");

    // Otomatis cek kesesuaian data tiket
    setValRootCause(Boolean(ticketSolved.summary && ticketSolved.summary.trim() !== ""));
    setValAction(Boolean(ticketSolved.action && ticketSolved.action.trim() !== ""));
    setValAging(Boolean(ticketSolved.tt_aging && ticketSolved.tt_aging.trim() !== "" && ticketSolved.tt_aging !== "Not Available"));

    // If backend already passed user_email, set it immediately
    if (ticketSolved.user_email) {
      setToEmail2(ticketSolved.user_email);
    }

    // Fetch user email by user_id from /users/:userId
    if (ticketSolved.user_id) {
      const fetchUserEmail = async () => {
        setUserLoading(true);
        try {
          const res = await newRequest.get(`/users/${ticketSolved.user_id}`);
          const userData = res.data?.data || res.data;
          if (userData?.email) {
            setToEmail2(userData.email);
          }
        } catch (err) {
          console.warn("Could not fetch user email for user_id:", ticketSolved.user_id, err);
        } finally {
          setUserLoading(false);
        }
      };

      fetchUserEmail();
    }
  }, [isOpen, ticketSolved?.ticket_id]);

  if (!isOpen || !ticketSolved) return null;

  const handleSendEmail = async () => {
    if (!isClosed) {
      Swal.fire({
        icon: "error",
        title: "Status Tiket Belum CLOSED",
        text: "Pengiriman email RFO hanya dapat dilakukan setelah tiket berstatus CLOSED. Silakan selesaikan dan close tiket terlebih dahulu.",
        confirmButtonColor: "#ef4444",
      });
      return;
    }

    const recipientList = [toEmail1, toEmail2].map(e => e.trim()).filter(Boolean);
    if (recipientList.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Perhatian",
        text: "Email penerima (To) wajib diisi minimal 1 alamat email (To 1 atau To 2)!",
        confirmButtonColor: "#0284c7",
      });
      return;
    }

    // Validasi 3 Pertanyaan
    const missingChecks = [];
    if (!valRootCause || !ticketSolved.summary || ticketSolved.summary.trim() === "") {
      missingChecks.push("1. Root Cause pada Tikor belum diisi / diverifikasi");
    }
    if (!valAction || !ticketSolved.action || ticketSolved.action.trim() === "") {
      missingChecks.push("2. Action pada Tikor belum diisi / diverifikasi");
    }
    if (!valAging || !ticketSolved.tt_aging || ticketSolved.tt_aging === "Not Available" || ticketSolved.tt_aging.trim() === "") {
      missingChecks.push("3. TT Aging belum sesuai / diverifikasi");
    }

    if (missingChecks.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Validasi Belum Sesuai",
        html: `
          <div style="text-align: left; font-size: 13.5px; line-height: 1.6;">
            <p>Mohon periksa dan centang kembali 3 pertanyaan validasi berikut:</p>
            <ul style="color: #b91c1c; padding-left: 20px; margin: 8px 0;">
              ${missingChecks.map(item => `<li>${item}</li>`).join("")}
            </ul>
          </div>
        `,
        confirmButtonColor: "#0284c7",
        confirmButtonText: "Periksa Kembali",
      });
      return;
    }

    const fullTo = recipientList.join(", ");
    const ccList = [ccEmail1, ccEmail2].map(e => e.trim()).filter(Boolean);
    const fullCc = ccList.join(", ");

    // Jika ketiganya sudah sesuai, tampilkan konfirmasi:
    // “Data sudah sesuai. Apakah Anda yakin ingin mengirim email?”
    // Batal | OK, Kirim
    const result = await Swal.fire({
      title: "Konfirmasi Kirim Email",
      text: "Data sudah sesuai. Apakah Anda yakin ingin mengirim email?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#0284c7",
      cancelButtonColor: "#64748b",
      confirmButtonText: "OK, Kirim",
      cancelButtonText: "Batal",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ticket_id: ticketSolved.ticket_id,
        to_email: fullTo,
        cc_email: fullCc,
        subject: subject,
        note: note,
      };

      await newRequest.post(`/solve/send-email/${ticketSolved.ticket_id}`, payload);

      Swal.fire({
        icon: "success",
        title: "Email Berhasil Dikirim!",
        html: `Laporan RFO telah berhasil dikirimkan ke <b>${fullTo}</b> via Zimbra Mail server (rfo@greenet.id).`,
        confirmButtonColor: "#0284c7",
      });

      onClose();
    } catch (err) {
      console.error("Error sending email:", err);
      const errMsg = err.response?.data?.errors || err.response?.data?.message || err.message || "Gagal mengirim email";
      Swal.fire({
        icon: "error",
        title: "Pengiriman Gagal",
        text: errMsg,
        confirmButtonColor: "#ef4444",
      });
    } finally {
      setLoading(false);
    }
  };

  const recipientPreview = [toEmail1, toEmail2].map(e => e.trim()).filter(Boolean).join(", ");
  const ccPreview = [ccEmail1, ccEmail2].map(e => e.trim()).filter(Boolean).join(", ");

  return (
    <div className="email-modal-overlay" onClick={onClose}>
      <div className="email-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="header-info">
            <div className="header-icon">📧</div>
            <div>
              <h3 className="header-title">Konfirmasi Pengiriman Email RFO</h3>
              <p className="header-subtitle">Pastikan data dan penerima email sudah sesuai sebelum dikirim</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Status Alert if NOT CLOSED */}
          {!isClosed ? (
            <div className="status-warning-banner">
              <span className="warning-icon">⚠️</span>
              <div>
                <strong>Tiket Belum Closed!</strong> Status tiket saat ini adalah <b>{ticketSolved.status_id || "SOLVED"}</b>.
                Sesuai aturan sistem, email RFO hanya dapat dikirimkan jika tiket telah di-close.
              </div>
            </div>
          ) : (
            <div className="status-success-banner">
              <span className="success-icon">✓</span>
              <div>
                <strong>Status Tiket Valid:</strong> Tiket telah berstatus <b>CLOSED</b> dan siap dikirimkan kepada pelanggan.
              </div>
            </div>
          )}

          {/* Form Fields: Email To 1 and To 2 */}
          <div className="form-row">
            <div className="form-group">
              <label>
                Email Penerima (To) 1 <span className="optional-tag">Pelanggan / PIC</span>
              </label>
              <input
                type="email"
                placeholder="Email pelanggan / pihak terkait (opsional)..."
                value={toEmail1}
                onChange={(e) => setToEmail1(e.target.value)}
              />
              <div className="hint">Alamat email pelanggan atau PIC perusahaan</div>
            </div>

            <div className="form-group">
              <label>
                Email Penerima (To) 2 <span className="required">* User Terdaftar</span>
                {ticketSolved.user_id && <span className="source-tag">User: {ticketSolved.user_id}</span>}
              </label>
              <input
                type="email"
                placeholder={userLoading ? "Memuat email user terdaftar..." : "Email user terdaftar..."}
                value={toEmail2}
                onChange={(e) => setToEmail2(e.target.value)}
              />
              <div className="hint">Otomatis diambil dari akun email user yang didaftarkan</div>
            </div>
          </div>

          {/* Form Fields: Email CC 1 and CC 2 */}
          <div className="form-row">
            <div className="form-group">
              <label>Email CC 1</label>
              <input
                type="text"
                placeholder="noc@greenet.id"
                value={ccEmail1}
                onChange={(e) => setCcEmail1(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Email CC 2 <span className="optional-tag">Opsional</span></label>
              <input
                type="text"
                placeholder="CC tambahan (contoh: admin@greenet.id)"
                value={ccEmail2}
                onChange={(e) => setCcEmail2(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Subjek Email <span className="required">*</span></label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Catatan Tambahan (Opsional)</label>
            <textarea
              rows="2"
              placeholder="Tambahkan catatan khusus jika diperlukan..."
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>

          {/* Email Preview Section */}
          <div className="preview-section">
            <div className="preview-header">
              <div className="preview-badge">GREENET NOC &bull; DATA CENTER</div>
              <h4 className="preview-title">Laporan Hasil Penanganan Gangguan (RFO)</h4>
              <div className="preview-sub">No. Tiket: {ticketNumber} &bull; Server Zimbra (rfo@greenet.id)</div>
            </div>
            <table className="preview-table">
              <tbody>
                <tr>
                  <td className="lbl">No. Registrasi / TT</td>
                  <td className="val text-bold">{ticketNumber}</td>
                </tr>
                <tr>
                  <td className="lbl">Penerima (To)</td>
                  <td className="val">{recipientPreview || "-"}</td>
                </tr>
                {ccPreview && (
                  <tr>
                    <td className="lbl">Tembusan (CC)</td>
                    <td className="val">{ccPreview}</td>
                  </tr>
                )}
                <tr>
                  <td className="lbl">Pelanggan / Perusahaan</td>
                  <td className="val">{ticketSolved.segment_customer || "-"}</td>
                </tr>
                <tr>
                  <td className="lbl">Status Tiket</td>
                  <td className="val">
                    <span className={`status-pill ${isClosed ? "status-closed" : "status-open"}`}>
                      {ticketSolved.status_id || "SOLVED"}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td className="lbl">Down Time</td>
                  <td className="val text-red">{dateInfo?.down_time || "-"}</td>
                </tr>
                <tr>
                  <td className="lbl">Up Time</td>
                  <td className="val text-green">{dateInfo?.up_time || "-"}</td>
                </tr>
                <tr>
                  <td className="lbl">Durasi (Aging)</td>
                  <td className="val text-bold">{ticketSolved.tt_aging || "Not Available"}</td>
                </tr>
                <tr>
                  <td className="lbl">Root Cause (Penyebab)</td>
                  <td className="val">{ticketSolved.summary || "-"}</td>
                </tr>
                <tr>
                  <td className="lbl">Tindakan Perbaikan (Action)</td>
                  <td className="val">{ticketSolved.action || "-"}</td>
                </tr>
                <tr>
                  <td className="lbl">Segment Customer</td>
                  <td className="val">{ticketSolved.segment_customer || "-"}</td>
                </tr>
                {note && (
                  <tr>
                    <td className="lbl">Catatan Tambahan</td>
                    <td className="val">{note}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 3 Pertanyaan Validasi Sebelum Email Dikirim */}
          <div className="validation-section">
            <div className="validation-header">
              <span className="validation-icon">📋</span>
              <div>
                <h4 className="validation-title">3 Pertanyaan Validasi Sebelum Email Dikirim:</h4>
                <p className="validation-desc">Pastikan ketiga poin di bawah telah diisi dan sesuai sebelum konfirmasi pengiriman:</p>
              </div>
            </div>

            <div className="validation-list">
              <div 
                className={`validation-item ${valRootCause ? "is-valid" : "is-invalid"}`}
                onClick={() => setValRootCause(!valRootCause)}
              >
                <input
                  type="checkbox"
                  id="chk-rootcause"
                  checked={valRootCause}
                  onChange={(e) => setValRootCause(e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                />
                <label htmlFor="chk-rootcause" onClick={(e) => e.stopPropagation()}>
                  <div className="q-label">1. Apakah Root Cause pada Tikor sudah diisi?</div>
                  <div className="q-value">
                    {ticketSolved.summary ? (
                      <span className="val-ok">✓ Terisi: "{ticketSolved.summary}"</span>
                    ) : (
                      <span className="val-bad">✗ Belum diisi pada tiket</span>
                    )}
                  </div>
                </label>
              </div>

              <div 
                className={`validation-item ${valAction ? "is-valid" : "is-invalid"}`}
                onClick={() => setValAction(!valAction)}
              >
                <input
                  type="checkbox"
                  id="chk-action"
                  checked={valAction}
                  onChange={(e) => setValAction(e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                />
                <label htmlFor="chk-action" onClick={(e) => e.stopPropagation()}>
                  <div className="q-label">2. Apakah Action pada Tikor sudah diisi?</div>
                  <div className="q-value">
                    {ticketSolved.action ? (
                      <span className="val-ok">✓ Terisi: "{ticketSolved.action}"</span>
                    ) : (
                      <span className="val-bad">✗ Belum diisi pada tiket</span>
                    )}
                  </div>
                </label>
              </div>

              <div 
                className={`validation-item ${valAging ? "is-valid" : "is-invalid"}`}
                onClick={() => setValAging(!valAging)}
              >
                <input
                  type="checkbox"
                  id="chk-aging"
                  checked={valAging}
                  onChange={(e) => setValAging(e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                />
                <label htmlFor="chk-aging" onClick={(e) => e.stopPropagation()}>
                  <div className="q-label">3. Apakah TT Aging sudah sesuai?</div>
                  <div className="q-value">
                    {ticketSolved.tt_aging && ticketSolved.tt_aging !== "Not Available" ? (
                      <span className="val-ok">✓ Sesuai: "{ticketSolved.tt_aging}"</span>
                    ) : (
                      <span className="val-bad">✗ TT Aging belum tersedia / belum di-close</span>
                    )}
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={loading}>
            Batal
          </button>
          <button
            className="btn btn-send"
            onClick={handleSendEmail}
            disabled={loading || !isClosed || (!toEmail1 && !toEmail2)}
            title={!isClosed ? "Tiket belum CLOSED" : (!toEmail1 && !toEmail2) ? "Email penerima wajib diisi" : ""}
          >
            {loading ? "Mengirim Email..." : "✉ Kirim Email Sekarang"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendEmailModal;
